export enum ActionType {
  LOGIN,
  LOGIN_FAILED,
}
